'use client'

import { getPasswordChecklist } from '@/lib/password-policy'

/**
 * Checklista wymagan hasla na zywo. Spelniony warunek = zielony, niespelniony = szary.
 * Bez emoji/emotikon — sam kolor + tekst + maly wskaznik CSS (kropka).
 *
 * Uzywany we wszystkich miejscach ustawiania/zmiany hasla, zeby user widzial
 * na biezaco czy haslo spelnia polityke.
 */
export default function PasswordChecklist({ password }: { password: string }) {
  const rules = getPasswordChecklist(password)
  return (
    <ul
      style={{
        listStyle: 'none',
        margin: '6px 0 0',
        padding: 0,
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4px 16px',
      }}
    >
      {rules.map((r) => (
        <li
          key={r.label}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: 12,
            lineHeight: 1.4,
            color: r.ok ? '#16a34a' : '#9ca3af',
            transition: 'color 0.15s',
          }}
        >
          <span
            aria-hidden="true"
            style={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              flexShrink: 0,
              background: r.ok ? '#16a34a' : 'transparent',
              border: r.ok ? '1px solid #16a34a' : '1px solid #cbd5e1',
            }}
          />
          {r.label}
        </li>
      ))}
    </ul>
  )
}
